const Footers = () => {
  return (
    <div className="footer-text">{`ICPBunny DAO © Copyright - ${new Date().getFullYear()}`}</div>
  );
};

export default Footers;
